import type { TabletColumns } from '@/components/WellLoggingOperations/types';

/*
    Словарь заголовков колонок. Зависит от типа TabletColumns
*/
export const columnsConfig: Record<TabletColumns, string> = {
    wellServices: 'Сервисные работы на скважине',
    allGeoObjects: 'РИГИС',
    geoObjects: 'Пласт',
    lithology: 'Литология/Насыщение',
    paramsHistogram: 'Гистограммы параметров',
    cementometry: 'Цементометрия',
    core: 'Керн',
    coreParamsHistogram: 'Параметры по керну',
    testing: 'Опробования пластов',
    flowmetry: 'Потокометрия',
    carrotage: 'Каротаж',
    fluidTest: 'Гидродинамические исследования',
    sample: 'ГРП',
    cementBondLogging: 'РИГИС остаточной нефтенасыщенности',
    stratigraphy: 'Стратиграфия',
    stratigraphy_system: 'Система',
    stratigraphy_department: 'Отдел',
    stratigraphy_tier: 'Ярус',
    stratigraphy_overhorizon: 'Надгоризионт',
    stratigraphy_horizon: 'Горизонт',
    innk: 'ИННК/ИГН',
    tracers: 'Маркерные исследования',
    tech: 'Тех. характеристики',
    tech_columns: 'Колонны',
    tech_cement: 'Цементаж',
    tech_bridges: 'Цем. мосты',
    thicknessInterlayer: 'Эффективная толщина',
};

/*
    Сопоставление ключа колонки с paramColumn.
    paramColumn - необходимый для записи в базу параметр, на клиенте используется для того,
    чтобы идентифицировать колонку (см paramColumnToColumnKey по проекту или файл useSettings.ts)
*/
export const columnKeyToParamColumn = {
    wellServices: 1,
    geoObjects: 2,
    lithology: 3,
    paramsHistogram: 5,
    cementometry: 6,
    carrotage: 7,
    core: 8,
    testing: 9,
    flowmetry: 10,
    fluidTest: 13,
    sample: 15,
    cementBondLogging: 16,
    stratigraphy: 17,
    tech: 18,
    thicknessInterlayer: 19,
    innk: 21,
    tracers: 22,
    allGeoObjects: 23, // добавить в базу
    tech_bridges: 24,
    tech_cement: 25,
    tech_columns: 26,
    coreParamsHistogram: 27,
};

const TOOLTIP_CONFIG: Record<TabletColumns, Array<{ keys: string[]; title: string }>> = {
    wellServices: [],
    allGeoObjects: [],
    geoObjects: [
        {
            keys: ['boredStratumAbsBottom', 'boredStratumAbsRoof'],
            title: 'Диапазон глубин, абс',
        },
        {
            keys: ['boredStratumBottom', 'boredStratumRoof'],
            title: 'Диапазон глубин, отн',
        },
        {
            keys: ['boredStratumAbsThin'],
            title: 'Толщина абс.',
        },
        {
            keys: ['boredStratumThin'],
            title: 'Толщина отн.',
        },
        {
            keys: ['boredStratumTitle'],
            title: 'Название',
        },
        {
            keys: ['boredStratumGnk'],
            title: 'Глубина ГНК',
        },
        {
            keys: ['boredStratumWnk'],
            title: 'Глубина ВНК',
        },
        {
            keys: ['params'],
            title: 'Параметры',
        },
    ],
    lithology: [
        {
            keys: ['boredSeamAbsBottom', 'boredSeamAbsRoof'],
            title: 'Диапазон глубин, абс',
        },
        {
            keys: ['boredSeamBottom', 'boredSeamRoof'],
            title: 'Диапазон глубин, отн',
        },
        {
            keys: ['boredSeamAbsThin'],
            title: 'Толщина абс.',
        },
        {
            keys: ['boredSeamThin'],
            title: 'Толщина отн.',
        },
        {
            keys: ['lithology'],
            title: 'Литология/Насыщение',
        },
        {
            keys: ['saturantTitle'],
            title: 'Насыщение',
        },
        {
            keys: ['params'],
            title: 'Параметры',
        },
    ],
    thicknessInterlayer: [
        {
            keys: ['boredSeamAbsBottom', 'boredSeamAbsRoof'],
            title: 'Диапазон глубин, абс',
        },
        {
            keys: ['boredSeamBottom', 'boredSeamRoof'],
            title: 'Диапазон глубин, отн',
        },
        {
            keys: ['boredSeamAbsThin'],
            title: 'Толщина абс.',
        },
        {
            keys: ['boredSeamThin'],
            title: 'Толщина отн.',
        },
        {
            keys: ['saturantTitle'],
            title: 'Насыщение',
        },
        {
            keys: ['params'],
            title: 'Параметры',
        },
    ],
    stratigraphy: [],
    paramsHistogram: [],
    cementBondLogging: [],
    cementometry: [],
    innk: [],
    tech: [],
    tech_columns: [],
    tech_bridges: [],
    tech_cement: [],
    carrotage: [],
    core: [],
    coreParamsHistogram: [],
    testing: [],
    flowmetry: [],
    fluidTest: [],
    sample: [],
    stratigraphy_system: [],
    stratigraphy_overhorizon: [],
    stratigraphy_horizon: [],
    stratigraphy_department: [],
    stratigraphy_tier: [],
    tracers: [],
};

export { TOOLTIP_CONFIG };

export const NON_RESIZABLE_COLUMNS: TabletColumns[] = ['geoObjects', 'lithology', 'thicknessInterlayer', 'paramsHistogram'];
export const NON_SETTINGS_COLUMNS: TabletColumns[] = ['paramsHistogram'];
